import { Box, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { TimeClockPicker } from "src/design";
import { TimeDisplay } from "./TimeDisplay";
import { colorSurfaceDisabled } from "src/design/tokens";

interface TimeFieldProps {
  label: string;
  value: Dayjs;
  editing: boolean;
  onChange: (value: Dayjs) => void;
  minTime?: Dayjs;
  maxTime?: Dayjs;
  disabled?: boolean;
  allowMidnightAsEndOfDay?: boolean;
}

export const TimeField = ({
  label,
  value,
  editing,
  onChange,
  minTime,
  maxTime,
  disabled,
  allowMidnightAsEndOfDay,
}: TimeFieldProps) => (
  <Box sx={{ flex: 1 }}>
    <Typography
      variant="caption"
      color='inherit'
      sx={{ fontWeight: 500, mb: 0.5, display: "block" }}
    >
      {label}
    </Typography>
    {editing ? (
      <TimeClockPicker
        value={value}
        onChange={onChange}
        minTime={minTime}
        maxTime={maxTime}
        disabled={disabled}
        variant='outlined'
        inputStyle={{
          backgroundColor: colorSurfaceDisabled,
        }}
        allowMidnightAsEndOfDay={allowMidnightAsEndOfDay}
      />
    ) : (
      <div style={{ width: '100%' }}>
        <TimeDisplay value={value} />
      </div>
    )}
  </Box>
);
